const TOAST_ERROR = 'TOAST_ERROR';
const PROFILE_COMPLETION_STATUS = 'PROFILE_COMPLETION_STATUS';
const SELECTED_CATEGORY = 'SELECTED_CATEGORY';
export { TOAST_ERROR, PROFILE_COMPLETION_STATUS, SELECTED_CATEGORY };
